import React, { useEffect } from 'react';
import { withTranslation } from '@wix/wix-i18n-config';
import WelcomePage from './WelcomePage';
import queryString from 'query-string';
import { welcomePageBiReporter } from './welcomePageBiReporter';
import { LogoUrlGenerator, ARENA_NAVIGATION_SOURCE } from '@wix/branding-client-lib';

const REFERRAL_OF_SHOW_ONE_TAP_DISCLAIMER = 'oneTapLogin';

function WelcomePageController(props) {
  const { t, options, companyDetails, queryParams, origins, logoUrlGenerator } = props;
  const { shouldShowHireDesigner } = options;
  const biReporter = new welcomePageBiReporter();

  const navigateWindow = (url, isNewWindow) => {
    if (isNewWindow) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  };

  const goToTermOfUse = () => navigateWindow(t('Logo_Purchase_Page_Disclaimer1_terms_link'), true);
  const goToPrivacy = () => navigateWindow(t('Logo_Purchase_Page_Disclaimer1_privacy_link'), true);
  const goToOnBoarding = () => {
    biReporter.reportGoToOnboarding(shouldShowHireDesigner);

    const { companyName } = companyDetails;
    const additionalParams = { ...queryParams };
    additionalParams.referralAdditionalInfo = origins.WELCOME_PAGE;

    delete additionalParams.debugApp;

    const finalParams = Object.entries(additionalParams).map(([key, value]) => {
      return { key, value };
    });

    const onboardingUrl = companyName ? logoUrlGenerator.getIndustryOnboardingUrl(finalParams) : logoUrlGenerator.getHomePageUrl(finalParams);

    navigateWindow(onboardingUrl, false);
  };
  const goToArena = () => {
    const mountPoint = window.__BASE_PATH__;
    const debugApp = window.__DEBUG_APP__;
    const host = window.location.host;
    const protocol = window.location.protocol;
    const logoUrlGenerator = new LogoUrlGenerator({ protocol, host, mountPoint, debugApp, isMobile: false });
    const finalUrl = logoUrlGenerator.getPartnersPageUrl(ARENA_NAVIGATION_SOURCE.USER_PROFILE_MENU);
    window.open(finalUrl, '_blank');
  };

  const referralInfo = queryString.parse(window.location.search).referralInfo ?? undefined;
  const shouldShowOneTapDisclaimer = referralInfo ? referralInfo === REFERRAL_OF_SHOW_ONE_TAP_DISCLAIMER : false;

  useEffect(() => {
    const { referralAdditionalInfo, biReporter } = props;
    const previousPage = referralAdditionalInfo && referralAdditionalInfo === 'mylogos' ? 'MyLogos' : 'LandingPage';
    biReporter.reportLogoPageView(previousPage);
  }, []);

  return (
    <WelcomePage
      t={t}
      onGoToOnBoarding={goToOnBoarding}
      onGoToArena={goToArena}
      shouldShowHireDesigner={shouldShowHireDesigner}
      shouldShowOneTapDisclaimer={shouldShowOneTapDisclaimer}
      onTermOfUseClicked={goToTermOfUse}
      onPrivacyClicked={goToPrivacy}
    />
  );
}

export default withTranslation()(WelcomePageController);
